import { getCookie } from "./cookies";
import axios from "./axios";

const isToken = getCookie("auth_token");
const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

export default {
  update: {
    changePassword(data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/user/update-password`, data, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateProfile(data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/user/profile`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updatePenciptaByIdUser(id_user, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/user/creator-update/${id_user}`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Keputusan publisher atas sebuah permintaan pendaftaran lagu.
     *
     * `approve: false` WAJIB disertai `decline_note` — backend menolak
     * penolakan tanpa alasan, karena pencipta butuh tahu apa yang direvisi.
     */
    reviewSong(song_id, approve, decline_note = "") {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/song/review/${song_id}`, {
            approve,
            decline_note,
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateSong(data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/song/song-update`, data)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAhliWaris(id_user, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/user/heir-update/${id_user}`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateStatusTransaksi(id, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/transaction/update-status/${id}`, data)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateTransaksi(id, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/transaction/${id}`, data)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAdmin(data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${BASE_URL}/api/user/admin-update`, data)
          .then((response) => {
            const { data } = response.data
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
};
